import { render, staticRenderFns } from "./market-item-orders-cards-item.vue?vue&type=template&id=4f77a8fa&scoped=true"
import script from "./market-item-orders-cards-item.vue?vue&type=script&lang=js"
export * from "./market-item-orders-cards-item.vue?vue&type=script&lang=js"
import style0 from "./market-item-orders-cards-item.vue?vue&type=style&index=0&id=4f77a8fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f77a8fa",
  null
  
)

export default component.exports